import { cn } from "@roman/shared/utils";
import type React from "react";

interface ChoiceCardProps {
  id: string;
  name: string;
  probability: number;
  commentCount?: number;
  color: string;
  backgroundColor: string;
  onClick: (id: string) => void;
  className?: string;
  percentage?: string;
  onCommentClick?: () => void;
}

export const ChoiceCard: React.FC<ChoiceCardProps> = ({
  id,
  name,
  probability,
  color,
  onClick,
  className,
  backgroundColor,
}) => {
  const percentage =
    probability * 100 >= 1 ? (Math.round(probability * 100) === 100 ? "99" : Math.round(probability * 100)) : "<1";
  return (
    <div
      className={cn(
        "text-sm grid grid-cols-[auto_1fr_auto] gap-2 items-center text-left rounded-sm p-2 cursor-pointer hover:bg-opacity-80 transition",
        className,
      )}
      style={{ backgroundColor: `${backgroundColor}` }}
      onClick={() => onClick(id)}
    >
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5" r="5" fill={color} />
      </svg>
      <div className="flex justify-between items-center w-full text-[14px] font-medium font-roboto">
        <span>{name}</span>
        <div className="flex items-center">
          <span className="text-[14px] font-bold">{percentage}%</span>
        </div>
      </div>
    </div>
  );
};
